import Sidebar from '../components/Sidebar'
import { useEffect, useState, useContext } from 'react'
import moment from 'moment';
import JSZip from "jszip";
import { saveAs } from "file-saver";
import SortableTable from '../components/SortableTable'
import Button from '@mui/material/Button';
import DateRangePicker from '../components/DateRangePicker';
import MultipleSelectCheckmarks from '../components/MultipleSelectDropdown'
import QrPopup from '../components/QrPopup';
import { DataContext } from '../context/dataContext';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import AdvanceDropDown from '../components/AdvanceDropDown';
import AdvancedSubGropuDropDown from '../components/AdvancedSubGroupDropdown';
import { getRevieweHistory, getImageFromCanvas, getScanDetails, getReviewScanDetails } from '../utils/api';
import Checkbox from '@mui/material/Checkbox';

function ReviewHistory() {
    const { crops } = useContext(DataContext);
    const { machines } = useContext(DataContext);
    const [ReviewHistory, setReviewHistory] = useState([]);
    const [isLoading, setIsLoading] = useState(false)
    const [dateRange, setDateRange] = useState('')
    const [selectedMachine, setSelectedMachine] = useState([]);
    const [expandedRows, setExpandedRows] = useState([]);
    const [selectedCrop, setSelectedCrop] = useState([]);
    const [varietyList, setVarietyList] = useState([])
    const [selectedVeriety, setSelectedVeriety] = useState([])
    const [uniqueCropList, setUniqueCropList] = useState([])
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectedRowsForExpansion, setSelectedRowForExpansion] = useState([]);
    const [clearDropdown, setClearDropdown] = useState(false);
    const [isPopupOpen, setPopupOpen] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');

    const formattedRows = ReviewHistory && (() => {

        // STEP 1: Keep latest per scan + subscan + review_index + original_class_name
        const uniqueMap = new Map();

        ReviewHistory.forEach((row) => {
            const key = `${row.scan_id}_${row.sub_scan_id}_${row.review_index}_${row.original_class_name}`;
            const existing = uniqueMap.get(key);

            if (!existing) {
                uniqueMap.set(key, row);
            } else {
                const existingDate = moment(existing.created_at, 'DD MMM, YYYY hh:mm A');
                const currentDate = moment(row.created_at, 'DD MMM, YYYY hh:mm A');

                if (currentDate.isAfter(existingDate)) {
                    uniqueMap.set(key, row);
                }
            }
        });

        const latestRows = Array.from(uniqueMap.values());

        // STEP 2: Now remove unchanged rows
        const modifiedRows = latestRows.filter(
            row => row.original_class_name !== row.changed_class_name
        );

        // STEP 3: Group by scan + subscan + user and count
        return modifiedRows.reduce((acc, row) => {

            const existingIndex = acc.findIndex(
                item =>
                    item.scan_id === row.scan_id &&
                    item.sub_scan_id === row.sub_scan_id &&
                    item.user_id === row.user_id
            );

            if (existingIndex === -1) {
                acc.push({
                    id: row.review_id,
                    ...row,
                    count: 1,
                    created_at: row.created_at,
                });
            } else {
                acc[existingIndex].count += 1;
            }

            return acc;

        }, []);

    })();

    const columns = [
        {
            field: 'checkbox',
            headerName: '',
            width: 50,
            headerClassName: 'table-background',
            editable: false,
            sortable: false,
            disableColumnMenu: true,
            renderHeader: () => (
                <Checkbox
                    checked={formattedRows.length > 0 && selectedRows.length === formattedRows.length}
                    onChange={handleSelectAll}
                    className='App-color'
                    inputProps={{ 'aria-label': 'select all' }}
                />
            ),
            renderCell: (params) => {
                return (
                    <Checkbox
                        checked={selectedRows.some((selectedRow) => selectedRow.review_id === params.row.review_id)}
                        onChange={() => handleCheckboxChange(params.row)}
                        className='App-color'
                        inputProps={{ 'aria-label': 'select checkbox' }}
                    />
                );
            },
        },
        {
            field: 'user_name',
            headerName: 'Login ID',
            flex: 1,
            width: 150,
            headerClassName: 'table-background',
            editable: false,
        },
        {
            field: 'full_name',
            headerName: 'User Name',
            width: 150,
            headerClassName: 'table-background',
            editable: false,
            renderCell: (params) => {
                const firstName = params.row?.first_name || '';
                const lastName = params.row?.last_name || '';
                const fullName = `${firstName} ${lastName}`.trim();
                return <div>{fullName || 'N/A'}</div>;
            },
        },
        {
            field: "contact_info",
            headerClassName: 'table-background',
            headerName: "Phone/Email",
            width: 150,
            renderCell: (params) => {
                const phoneNumber = params.row?.phone_number;
                const email = params.row?.email;
                return <div>{phoneNumber || email || "N/A"}</div>;
            },
        },
        {
            field: 'scan_id',
            headerName: 'Scan ID',
            width: 150,
            headerAlign: 'center',
            align: 'center',
            headerClassName: 'table-background',
            editable: false,
        },
        {
            field: 'sub_scan_id',
            headerName: 'Sub Scan ID',
            width: 100,
            type: 'number',
            align: 'center',
            headerAlign: 'center',
            headerClassName: 'table-background',
            editable: false,
        },
        {
            field: 'count',
            headerName: 'Count',
            type: 'number',
            headerAlign: 'center',
            align: 'center',
            headerClassName: 'table-background',
            width: 100,
            editable: false,
        },
        {
            field: 'created_at',
            headerName: 'Time Stamp',
            headerAlign: 'center',
            align: 'center',
            headerClassName: 'table-background',
            width: 220,
            editable: false,
        },
        {
            field: 'updated_by',
            headerName: 'Updated By',
            flex: 1,
            width: 150,
            headerClassName: 'table-background',
            editable: false,
        },
        {
            field: 'actions',
            headerName: 'Actions',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            headerClassName: 'table-background',
            width: 120,
            sortable: false,
            editable: false,
            disableColumnMenu: true,
            renderCell: (params) => (
                <Button variant="contained" className='App-bg-color' onClick={() => handleExpandRow(params.row)}>
                    View
                </Button>
            ),
        },
    ];

    const expandedColumns = [
        {
            field: 'checkbox',
            headerName: '',
            width: 50,
            headerClassName: 'table-background',
            editable: false,
            sortable: false,
            disableColumnMenu: true,
            renderHeader: () => (
                <Checkbox
                    checked={expandedRows.length > 0 && selectedRowsForExpansion.length === expandedRows.length}
                    onChange={handleSelectAllForExpansion}
                    color="primary"
                    inputProps={{ 'aria-label': 'select all' }}
                />
            ),
            renderCell: (params) => {
                return (
                    <Checkbox
                        checked={selectedRowsForExpansion.some((selectedRow) => selectedRow.review_id === params.row.review_id)}
                        onChange={() => handleCheckboxChangeForExpansion(params.row)}
                        color="primary"
                        inputProps={{ 'aria-label': 'select checkbox' }}
                    />
                );
            },
        },
        {
            field: 'user_name',
            headerName: 'Login ID',
            width: 150,
            headerClassName: 'table-background',
            editable: false,
        },
        {
            field: 'full_name',
            headerName: 'User Name',
            width: 150,
            headerClassName: 'table-background',
            editable: false,
            renderCell: (params) => {
                const firstName = params.row?.first_name || '';
                const lastName = params.row?.last_name || '';
                const fullName = `${firstName} ${lastName}`.trim();
                return <div>{fullName || 'N/A'}</div>;
            },
        },
        {
            field: "contact_info",
            headerClassName: 'table-background',
            headerName: "Phone/Email",
            width: 150,
            renderCell: (params) => {
                const phoneNumber = params.row?.phone_number;
                const email = params.row?.email;
                return <div>{phoneNumber || email || "N/A"}</div>;
            },
        },
        {
            field: 'scan_id',
            headerName: 'Scan ID',
            width: 150,
            headerAlign: 'center',
            align: 'center',
            headerClassName: 'table-background',
            editable: false,
        },
        {
            field: 'sub_scan_id',
            headerName: 'Sub Scan ID',
            width: 100,
            type: 'number',
            align: 'center',
            headerAlign: 'center',
            headerClassName: 'table-background',
            editable: false,
        },
        {
            field: 'review_index',
            headerName: 'Index',
            type: 'number',
            headerAlign: 'center',
            align: 'center',
            headerClassName: 'table-background',
            width: 100,
            editable: false,
        },
        {
            field: 'created_at',
            headerName: 'Time Stamp',
            headerAlign: 'center',
            align: 'center',
            headerClassName: 'table-background',
            width: 180,
            editable: false,
        },
        {
            field: 'image',
            headerName: 'Image',
            headerAlign: 'center',
            align: 'center',
            headerClassName: 'table-background',
            width: 100,
            editable: false,
        },
        {
            field: 'original_class_name',
            headerName: 'Original ClassName',
            headerClassName: 'table-background',
            width: 150,
            editable: true,
        },
        {
            field: 'changed_class_name',
            headerName: 'Change ClassName',
            headerClassName: 'table-background',
            width: 150,
            editable: true,
        },
        {
            field: 'updated_by',
            headerName: 'Updated By',
            flex: 1,
            width: 150,
            headerClassName: 'table-background',
            editable: false,
        },
    ];

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') return;
        setSnackbarOpen(false);
    };

    const handleSelectAll = (event) => {
        setSelectedRows(event.target.checked ? formattedRows : []);
    };

    const handleSelectAllForExpansion = (event) => {
        setSelectedRowForExpansion(event.target.checked ? expandedRows : []);
    };

    const handleCheckboxChange = (row) => {
        const scanId = row.scan_id;
        const subscanId = row.sub_scan_id;
        const Rows = formattedRows.filter(
            (item) =>
                item.scan_id === scanId &&
                item.sub_scan_id === subscanId &&
                item.user_id === row.user_id
        );

        setSelectedRows((prevSelectedRows) => {
            const rowIds = Rows.map((r) => r.review_id);
            const isSelected = rowIds.some((id) =>
                prevSelectedRows.some((selectedRow) => selectedRow.review_id === id)
            );
            if (isSelected) {
                return prevSelectedRows.filter((selectedRow) => !rowIds.includes(selectedRow.review_id));
            } else {
                return [...prevSelectedRows, ...Rows];
            }
        });
    };

    const handleCheckboxChangeForExpansion = (row) => {
        setSelectedRowForExpansion((prevSelectedRows) => {
            const rowId = row.review_id;
            if (prevSelectedRows.some((selectedRow) => selectedRow.review_id === rowId)) {
                return prevSelectedRows.filter((selectedRow) => selectedRow.review_id !== rowId);
            } else {
                return [...prevSelectedRows, row];
            }
        });
    };

    const handleExpandRow = async (row) => {
        try {
            setSnackbarMessage('Loading ...');
            setSnackbarOpen(true);

            const payload = {
                scan_id: row.scan_id,
                sub_scan_id: row.sub_scan_id,
            };

            const reviewRes = await getReviewScanDetails(payload);
            const reviewRows = reviewRes?.data?.data || [];
            const uniqueMap = new Map();

            reviewRows.forEach((item) => {
                const key = `${item.review_index}_${item.original_class_name}`;
                const existing = uniqueMap.get(key);

                if (!existing) {
                    uniqueMap.set(key, item);
                } else {
                    const existingDate = moment(existing.created_at, 'DD MMM, YYYY hh:mm A');
                    const currentDate = moment(item.created_at, 'DD MMM, YYYY hh:mm A');

                    if (currentDate.isAfter(existingDate)) {
                        uniqueMap.set(key, item);
                    }
                }
            });

            const latestRows = Array.from(uniqueMap.values());

            const modifiedRows = latestRows.filter(
                item => item.original_class_name !== item.changed_class_name
            );

            const expandedRowsWithIndex = await Promise.all(
                modifiedRows.map(async (item, index) => {
                    const {
                        coordinates,
                        scan_id,
                        sub_scan_id,
                        original_class_name,
                        review_index,
                        changed_class_name,
                    } = item;

                    const boundingBoxString = JSON.stringify(coordinates);

                    const { cropUrl, fileName } = await handleCropImage(
                        boundingBoxString,
                        scan_id,
                        sub_scan_id,
                        original_class_name,
                        review_index,
                        changed_class_name,
                        reviewRes?.data
                    );

                    return {
                        ...item,
                        id: index,
                        image: cropUrl,
                        fileName,
                    };
                })
            );

            setExpandedRows(expandedRowsWithIndex);
            setPopupOpen(true);

        } catch (err) {
            console.error(err);
            setSnackbarMessage('Failed to load review data');
        } finally {
            setSnackbarOpen(false);
        }
    };

    useEffect(() => {
        const uniqueObjects = crops?.length && crops.reduce((unique, currentObj) => {
            const isDuplicate = unique.some(obj => obj.crop_name === currentObj.crop_name);
            if (!isDuplicate) { unique.push(currentObj); }
            return unique;
        }, []);
        setUniqueCropList(uniqueObjects);
    }, [crops]);

    useEffect(() => {
        if (selectedCrop?.length) {
            const all_verites_crops = crops?.length && crops.filter(item =>
                selectedCrop.some(selectedItem => selectedItem.crop_name === item.crop_name)
            );

            const perfectCrops = all_verites_crops.filter(item =>
                item?.variety_name?.toLowerCase().includes('perfect')
            );

            const filteredCrops = all_verites_crops.filter(item =>
                !item?.variety_name?.toLowerCase().includes('perfect')
            );

            const output_list = filteredCrops.reduce((accumulator, crop) => {
                const existingCrop = accumulator.find((item) => item.title.toLowerCase() === crop.crop_name.toLowerCase());
                if (existingCrop) {
                    existingCrop.data.push(crop);
                } else {
                    accumulator.push({
                        title: crop.crop_name,
                        data: [crop],
                    });
                }
                return accumulator;
            }, []);

            if (perfectCrops.length) {
                output_list.push({
                    title: 'Custom Variety',
                    data: perfectCrops,
                });
            }

            setVarietyList(output_list);
        } else {
            setVarietyList([]);
        }
    }, [selectedCrop, crops]);

    const handleMachineChange = (value) => {
        setSelectedMachine(value);
    };

    const handleButtonClick = async () => {
        setIsLoading(true);
        const combinations = selectedVeriety.flatMap((variety) =>
            selectedMachine.map((machine) => ({
                crop_id: variety.crop_id,
                variety_id: variety.variety_id,
                machine_id: machine.machine_id,
            }))
        );

        const payload = {
            crop_variety_machine: combinations,
            start_date: dateRange?.start_date,
            end_date: dateRange?.end_date,
        };
        const response = await getRevieweHistory(payload);
        response?.data && setReviewHistory(response.data?.data);
        setTimeout(() => {
            setIsLoading(false);
        }, 10000);
    };

    const handleRefreshClick = () => {
        setClearDropdown(true);
        setReviewHistory([]);
        setSelectedMachine([]);
        setSelectedCrop([]);
        setDateRange('');
    };

    const handleDownloadJson = async () => {
        setSnackbarMessage('Downloading ...');
        setSnackbarOpen(true);

        if (!selectedRows || selectedRows.length === 0) return;

        const selectedScanKeys = new Set(
            selectedRows.map(row =>
                `${row.scan_id}_${row.sub_scan_id}_${row.user_id}`
            )
        );

        // STEP 1: Pull all raw records matching selected scan+subscan+user combos
        const matchingRawRows = ReviewHistory.filter(row =>
            selectedScanKeys.has(
                `${row.scan_id}_${row.sub_scan_id}_${row.user_id}`
            )
        );

        // STEP 2: Deduplicate FIRST (keep latest)
        const uniqueSelectedRowsMap = new Map();

        matchingRawRows.forEach((row) => {
            const key = `${row.scan_id}_${row.sub_scan_id}_${row.review_index}_${row.original_class_name}`;
            const existingRow = uniqueSelectedRowsMap.get(key);

            if (!existingRow) {
                uniqueSelectedRowsMap.set(key, row);
            } else {
                const existingDate = moment(existingRow.created_at, 'DD MMM, YYYY hh:mm A');
                const currentDate = moment(row.created_at, 'DD MMM, YYYY hh:mm A');

                if (currentDate.isAfter(existingDate)) {
                    uniqueSelectedRowsMap.set(key, row);
                }
            }
        });

        const latestRows = Array.from(uniqueSelectedRowsMap.values());

        // STEP 3: Now remove unchanged rows
        const modifiedRows = latestRows.filter(
            row => row.original_class_name !== row.changed_class_name
        );

        // STEP 4: Group by scan + subscan
        const grouped = {};

        modifiedRows.forEach((row) => {
            const groupKey = `${row.scan_id}_${row.sub_scan_id}`;
            if (!grouped[groupKey]) {
                grouped[groupKey] = [];
            }
            grouped[groupKey].push(row);
        });

        // STEP 5: Create ZIP
        const zip = new JSZip();

        Object.keys(grouped).forEach((key) => {
            zip.file(
                `${key}.json`,
                JSON.stringify(grouped[key], null, 2)
            );
        });

        const content = await zip.generateAsync({ type: "blob" });

        const currentDate = moment();
        const formattedDate = currentDate.format('DD_MM_YYYY');
        const formattedTime = currentDate.format('HH_mm');

        saveAs(content, `Reviewed_${formattedDate}_${formattedTime}.zip`);

        setSnackbarMessage('Download completed successfully!');
        setTimeout(() => setSnackbarOpen(false), 3000);
    };

    const handleDownloadForExpansion = async () => {
        setSnackbarMessage('Downloading ...');
        setSnackbarOpen(true);

        if (!selectedRowsForExpansion || selectedRowsForExpansion.length === 0) {
            return;
        }

        const filteredRows = selectedRowsForExpansion
            .filter(row => row.original_class_name !== row.changed_class_name)
            .map(({ image, scan_files, ...cleanRow }) => cleanRow);

        if (filteredRows.length === 0) {
            setSnackbarMessage('No modified records to download');
            setTimeout(() => setSnackbarOpen(false), 3000);
            return;
        }

        const firstRow = filteredRows[0];

        const currentDate = moment();
        const formattedDate = currentDate.format('DD_MM_YYYY');
        const formattedTime = currentDate.format('HH_mm');

        const fileName = `${firstRow.scan_id}_${firstRow.sub_scan_id}_Reviewed_${formattedDate}_${formattedTime}.json`;

        const blob = new Blob(
            [JSON.stringify(filteredRows, null, 2)],
            { type: 'application/json' }
        );

        const link = document.createElement('a');
        link.download = fileName;
        link.href = window.URL.createObjectURL(blob);
        link.click();

        setSnackbarMessage('Download completed successfully!');
        setTimeout(() => setSnackbarOpen(false), 3000);
    };

    const downloadZip = async (validCroppedUrls, capturedWebpUrlForBottom) => {
        const zip = new JSZip();
        const folder = zip.folder('Images');
        validCroppedUrls && validCroppedUrls.forEach(({ imageData, fileName }) => {
            folder.file(fileName, imageData, { base64: true });
        });
        if (capturedWebpUrlForBottom !== null) {
            capturedWebpUrlForBottom && capturedWebpUrlForBottom.forEach(({ imageData, fileName }) => {
                folder.file(`bottom_image_${fileName}`, imageData, { base64: true });
            });
        }
        zip.generateAsync({ type: 'blob' }).then((content) => {
            const link = document.createElement('a');
            link.href = URL.createObjectURL(content);
            link.download = 'Images.zip';
            link.click();
        });
    };

    const handleCropImage = async (boundingBoxString, scanID, subScanID, originalClassName, index, changedClassName, scanData) => {
        if (scanData?.data) {
            let fileName = `${scanID}_${subScanID}_${originalClassName} - ${changedClassName}_${index}.png`;
            const capturedImageFileNames = ['captured.webp', 'captured.png', 'captured.jpeg', 'captured.jpg'];
            const capturedImageFiles = capturedImageFileNames.map((fileName) =>
                scanData?.data[0]?.scan_files.find((file) => file.file_name === fileName)
            );
            const capturedWebpFileForBottom = scanData?.data[0]?.scan_files?.find(
                (file) => file.file_name?.includes('captured_bottom')
            );

            let capturedWebpUrlForBottom = capturedWebpFileForBottom?.file_url;
            if (!capturedWebpUrlForBottom) {
                const fileWithCvServer = scanData?.data[0]?.scan_files.find(
                    (file) => file.file_name.includes('_bottom_cv_server')
                );
                capturedWebpUrlForBottom = fileWithCvServer?.file_url || null;
            }
            const capturedWebpUrl =
                capturedImageFiles.find((file) => file !== undefined)?.file_url ||
                scanData?.data[0]?.scan_files.find((file) => file.file_name.includes('_cv_server'))?.file_url ||
                null;

            const cropUrl = capturedWebpUrl ? await getImageFromCanvas(capturedWebpUrl, boundingBoxString, true) : null;
            let boxesUrlForBottom = null;
            if (capturedWebpUrlForBottom !== null) {
                boxesUrlForBottom = await getImageFromCanvas(capturedWebpUrlForBottom, boundingBoxString);
            }
            return { cropUrl, boxesUrlForBottom, fileName };
        }
    };

    const handleDownloadImages = async () => {
        setSnackbarMessage('Downloading images...');
        setSnackbarOpen(true);

        const selectedScanKeys = new Set(
            selectedRows.map(row => `${row.scan_id}_${row.sub_scan_id}_${row.user_id}`)
        );

        const matchingRawRows = ReviewHistory.filter(row =>
            selectedScanKeys.has(`${row.scan_id}_${row.sub_scan_id}_${row.user_id}`) &&
            row.original_class_name !== row.changed_class_name
        );

        const uniqueCombinations = new Map();
        matchingRawRows.forEach((obj) => {
            const combination = `${obj.review_index}_${obj.original_class_name}`;
            const existingObj = uniqueCombinations.get(combination);

            if (!existingObj) {
                uniqueCombinations.set(combination, obj);
            } else {
                const existingDate = moment(existingObj.created_at, 'DD MMM, YYYY hh:mm A');
                const currentDate = moment(obj.created_at, 'DD MMM, YYYY hh:mm A');

                if (currentDate.isAfter(existingDate)) {
                    uniqueCombinations.set(combination, obj);
                }
            }
        });

        const filteredKernel = Array.from(uniqueCombinations.values());

        if (filteredKernel.length === 0) {
            setSnackbarMessage('No images to Download.');
            setTimeout(() => setSnackbarOpen(false), 3000);
            return;
        }
        if (filteredKernel.length > 100) {
            setSnackbarMessage('Please select a maximum of 5 Scans.');
            setSnackbarOpen(true);
            return;
        }

        const cropImagePromises = filteredKernel.map(async (item) => {
            const { coordinates, scan_id, sub_scan_id, original_class_name, review_index, changed_class_name } = item;
            const boundingBoxString = JSON.stringify(coordinates);
            const payload = { scan_id, sub_scan_id };
            const scanData = await getScanDetails(payload);
            return handleCropImage(boundingBoxString, scan_id, sub_scan_id, original_class_name, review_index, changed_class_name, scanData?.data);
        });

        const croppedUrlsWithNames = await Promise.all(cropImagePromises);
        const validCroppedUrls = [];
        const capturedWebpUrlForBottom = [];

        croppedUrlsWithNames?.forEach(({ cropUrl, boxesUrlForBottom, fileName }) => {
            if (cropUrl !== null && cropUrl !== undefined) {
                validCroppedUrls.push({ imageData: cropUrl.split(',')[1], fileName });
            }
            if (boxesUrlForBottom !== null && boxesUrlForBottom !== undefined) {
                capturedWebpUrlForBottom.push({ imageData: boxesUrlForBottom.split(',')[1], fileName });
            }
        });

        downloadZip(validCroppedUrls, capturedWebpUrlForBottom);
        setSnackbarMessage('Download completed successfully!');
        setTimeout(() => setSnackbarOpen(false), 3000);
    };

    const handleSubScanSelect = async (scanId, subScan) => {
        setIsLoading(true);
        try {
            const payload = { scan_id: scanId, sub_scan_id: subScan };
            const response = await getReviewScanDetails(payload);
            if (response?.data?.data) {
                setReviewHistory(response.data.data);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="user-container"><Sidebar isArrow />
            <div className="user-content">
                <div className="table-input m-b-20">
                    <div className="input-group">
                        {crops && crops.length > 0 && (
                            <>
                                <AdvanceDropDown
                                    title="Crop"
                                    width={200}
                                    data_list={uniqueCropList}
                                    unique_key={'crop_id'}
                                    show_options_item={(option) => `${option.crop_name}`}
                                    show_name_on_drop_down_box={(option) => `${option.crop_name}`}
                                    filter_items={['crop_name']}
                                    get_selected_data={setSelectedCrop}
                                    reset_drop_down={clearDropdown}
                                    required={true}
                                />
                                <div style={{ marginLeft: 10 }}>
                                    <AdvancedSubGropuDropDown
                                        title='Variety'
                                        data_list={varietyList}
                                        unique_key={'variety_id'}
                                        show_options_item={(option) => `${option.variety_name}`}
                                        show_name_on_drop_down_box={(option) => `${option.variety_name}`}
                                        filter_items={['variety_name']}
                                        width={200}
                                        get_selected_data={setSelectedVeriety}
                                        reset_drop_down={clearDropdown}
                                        required
                                    />
                                </div>
                            </>
                        )}
                        {machines && machines.length > 0 && (
                            <MultipleSelectCheckmarks
                                title="Machine"
                                valueKey="machine_id"
                                options={machines}
                                value={selectedMachine}
                                onChange={handleMachineChange}
                                isLoading={isLoading}
                                clearDropdown={clearDropdown}
                                displayFormat={(option) => `${option.machine_name} - ${option.machine_code}`}
                                isRequired={true}
                            />
                        )}
                    </div>
                    <div className="input-group">
                        <DateRangePicker setDateRange={setDateRange} />
                    </div>
                    <div className="input-group">
                        <Button variant="contained" className='App-bg-color' onClick={handleButtonClick} disabled={!(selectedCrop && selectedMachine)}>
                            VIEW
                        </Button>
                    </div>
                    <div className="input-group">
                        <Button variant="contained" className='App-bg-color-2' onClick={handleRefreshClick} style={{ fontSize: '0.8rem', backgroundColor: 'red' }}>
                            Reset
                        </Button>
                    </div>
                </div>

                {isPopupOpen && (
                    <QrPopup
                        open={isPopupOpen}
                        onClose={() => setPopupOpen(false)}
                        title='View Changes'
                        tabledata
                        rows={expandedRows}
                        setSelectedRowForExpansion={setSelectedRowForExpansion}
                        selectedRowsForExpansion={selectedRowsForExpansion}
                        handleDownloadForExpansion={handleDownloadForExpansion}
                        expandedColumns={expandedColumns}
                    />
                )}

                <div>
                    <SortableTable
                        rows={formattedRows}
                        columns={columns}
                        expandedColumns={expandedColumns}
                        isLoading={isLoading}
                        isSearchForReview
                        selectedRows={selectedRows}
                        handleDownloadJson={handleDownloadJson}
                        handleDownloadImages={handleDownloadImages}
                        expandedRows={expandedRows}
                        onSubScanSelect={handleSubScanSelect}
                    />
                </div>
            </div>

            <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose}>
                <MuiAlert elevation={6} variant="filled" onClose={handleSnackbarClose} severity="success">
                    {snackbarMessage}
                </MuiAlert>
            </Snackbar>
        </div>
    );
}

export default ReviewHistory;